import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { NvmBanner } from "./NvmBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Fhifaagc4%2Fnvm-wonen-ondertekening-koopcontract-beeldstories-6571-web.jpg%3Fwidth%3D3840%26quality%3D100&w=1080&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
  documentsOutgoing:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Fh2ulnncx%2Ftmptsh_53wx_v2.png%3Fwidth%3D3840%26quality%3D100&w=1920&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
  documentsIncoming:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Fh2ulnncx%2Ftmptsh_53wx_v2.png%3Fwidth%3D3840%26quality%3D100&w=1920&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
  interestRates:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Fl4xp0khg%2Fnvm-wonen-scene-beeldstories-web-7426.jpg%3Fwidth%3D3840%26quality%3D100&w=1920&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
  maximumMortgage:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Frmtfn22e%2Fnvm-scene-utrecht-stad-urban-rogier-boogaard-untitled-0347-enhanced-nr-web.jpg%3Fwidth%3D3840%26quality%3D100&w=1920&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
  orientation:
    "https://www.nvm.nl/_next/image/?url=%2Fapi%2Fassets%2Fmedia%2Fouefbqm2%2Fnvm-wonen-scene-beeldstories-web-7199.jpg%3Fwidth%3D3840%26quality%3D100&w=1920&q=90&dpl=dpl_GNLhA1Ev3TUMaxjyqbE3VFdsHteQ",
};

export const NvmPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <NvmBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
